/**
 * Yerel (cihazin saat dilimine gore) tarihi YYYY-AA-GG olarak dondurur.
 *
 * `new Date().toISOString().split("T")[0]` UTC tarihini verir; Turkiye UTC+3
 * oldugu icin gece 00:00 - 03:00 arasinda bir onceki gunu yaziyordu. Bu yuzden
 * hem form varsayilanlarinda hem gunluk raporda bu yardimci kullanilmali.
 */
export function todayLocalISO(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export default todayLocalISO;
